import { create } from 'zustand'

export type SSEStatus = 'connecting' | 'open' | 'closed' | 'error'

type ConnectionRecord = {
  name: string
  status: SSEStatus
  reconnectCount: number
}

type ConnectionStatusStore = {
  connections: Record<string, ConnectionRecord>
  registerConnection: (name: string) => void
  updateStatus: (name: string, status: SSEStatus) => void
  incrementReconnect: (name: string) => void
  unregisterConnection: (name: string) => void
}

export const useConnectionStatusStore = create<ConnectionStatusStore>((set) => ({
  connections: {},
  registerConnection: (name) => set((s) => ({
    connections: { ...s.connections, [name]: { name, status: 'connecting', reconnectCount: 0 } }
  })),
  updateStatus: (name, status) => set((s) => ({
    connections: s.connections[name]
      ? { ...s.connections, [name]: { ...s.connections[name], status } }
      : s.connections
  })),
  incrementReconnect: (name) => set((s) => ({
    connections: s.connections[name]
      ? { ...s.connections, [name]: { ...s.connections[name], reconnectCount: s.connections[name].reconnectCount + 1 } }
      : s.connections
  })),
  unregisterConnection: (name) => set((s) => {
    const { [name]: _removed, ...rest } = s.connections
    void _removed
    return { connections: rest }
  }),
}))
